import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const SubGridContainer = styled("div")(() => ({
  padding: 0,
  position: "relative",
  margin: "-1px",
  "& .MuiTableBody-root tr.MuiTableRow-root:nth-of-type(odd)": {
    backgroundColor: `${colors.gray50} !important`,
  },
  "& > div > div > div > table > tbody > tr": {
    backgroundColor: `${colors.gray50} !important`,
    "& td": {
      padding: "20px 8px !important",
    },
    "&:not(:last-child)": {
      borderBottom: "1px solid rgba(237, 245, 251, 1) !important",
    },
  },
  "& .tableContainerX": {
    borderRadius: "0px",
  },
  "& table thead": {
    backgroundColor: `${colors.blue25} !important`,
  },
  "& .MuiTableContainer-root": {
    overflowX: "hidden !important",
  },
}));

export const ModeIconColumn = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const styles = makeStyles(() => ({
  icon: { width: "5%" },
  item: { width: "32%" },
  quantity: { width: "32%" },
  weight: { width: "31%" },
}));

export default styles;
